import { useQuery } from '@tanstack/react-query';

import { SHARED_QUERY_KEYS } from '@shared/consts/queryKeys.ts';
import { getUserProfileService } from '@shared/services/userProfile/service';
import { transformGetUserProfileDTO } from '@shared/services/userProfile/service.dto';
import { DataStatuses } from '@shared/types/common';
import { ONBOARDING_STATE } from '@shared/types/userProfile.types.ts';

interface UserProfileDataProps {
  canFetchUserProfileData: boolean;
}

export function useUserProfileData({ canFetchUserProfileData }: UserProfileDataProps) {
  const {
    data,
    isPending: userProfileDataIsPending,
    isFetched: userProfileDataIsFetched,
  } = useQuery({
    queryKey: [SHARED_QUERY_KEYS.BILLING_INFO],
    queryFn: () => getUserProfileService(),
    enabled: canFetchUserProfileData,
  });

  const userProfileData = transformGetUserProfileDTO(data);
  const isFormVisible = userProfileData?.status === DataStatuses.PENDING;
  const isUserProfileDataApproved = userProfileData?.status === DataStatuses.APPROVED;
  const isBillingInfoProvided = userProfileData?.status !== DataStatuses.PENDING;
  const isOnboardingCompleted = userProfileData?.onboardingState === ONBOARDING_STATE.COMPLETED;
  const canEditUserProfile = userProfileData?.status === DataStatuses.IN_APPROVAL;

  return {
    userProfileData,
    userProfileDataIsPending,
    userProfileDataIsFetched,
    isFormVisible,
    isUserProfileDataApproved,
    isBillingInfoProvided,
    isOnboardingCompleted,
    onboardingState: userProfileData?.onboardingState,
    canEditUserProfile,
  };
}
